import React from 'react';

import '../../styles/pcr.scss';

export default ({ children }: { children: React.ReactNode }) => {
  return <div id="pcr-toolbar">{children}</div>;
};
